<template>
  <div>
    <!--头部信息-->
    <div class="factoring">
      <div class="factoring_Img">
        <img src="../../assets/images/product.jpg" alt="">
      </div>
      <div class="factoring_tit w">

        <!-- <h2 class="factoring_h">{{productName}}</h2> -->
        <h2 class="factoring_h" v-if="this.$route.query.yanse == 1">供应链融资</h2>
        <h2 class="factoring_h" v-if="this.$route.query.yanse == 2">{{this.$route.query.productName}}</h2>
        <div class="limit-baoli">
          <ul>
            <li class="limit" v-if="this.$route.query.yanse == 1">
              <p>关于额度</p>
              <span style="text-indent:2em;">供应链融资是以供应商共享买方的银行授信额度为前提的融资方式。额度的具体使用会根据合作银行的不同分为先占先用或买方主动分配等。</span>
            </li>
            <li class="limit" v-if="this.$route.query.yanse == 1">
              <p>关于账户</p>
              <span style="text-indent:2em;">供应链融资需要供应商在买方授信所在银行具有一般结算账户，在此账户基础上设立专用于供应链融资的回款专户。</span><br>
              <span style="text-indent:2em;">回款专户不可操作，属于买方应付到期时支付货款的指定路径。</span>
            </li>    
            <li class="limit" v-if="this.$route.query.yanse == 2 && this.$route.query.productName =='正向保理'">
              <p>客户准入</p>
              <span style="text-indent:2em;">客户在本系统提交相关信息完成实名认证后，签订《商业保理合同》开通融资权限及可用额度</span>
            </li>
            <li class="limit" v-if="this.$route.query.yanse == 2 && this.$route.query.productName =='正向保理'">
              <p>业务申请</p>
              <span style="text-indent:2em;">客户在本系统录入与应收账款相关的资料（发票及贸易合同等），我司将对贸易真实性进行审核，并根据融资产品及客户信用状况进行具体业务的审批</span>
            </li>                    
            <li class="limit" v-if="this.$route.query.yanse == 2 && this.$route.query.productName !='正向保理'">
              <p>额度申请</p>
              <span>客户有意向平台发起融资申请时，需要先进行额度申请，平台对客户进行尽调，授信一定的额度，客户可在额度范围内进行融资申请。</span>
            </li>
            <li class="limit" v-if="this.$route.query.yanse == 2 && this.$route.query.productName !='正向保理'">
              <p>融资申请</p>
              <span>供应商可录入贸易合同及应收账款信息相本平台发起融资申请，平台对客户的融资申请进行审核，根据客户申请的融资类型及信用状况确定融资</span>
            </li>
        </ul>
        <button class="factoring_btn" @click="beginApplyLoan()">立即申请</button>
        </div>
      </div>
    </div>
    <!--头部信息-->
    <!--主要内容-->
    <div class="factoring_main w">
      <!--导航-->
      <div class="factoring_nav tit_public" v-if="this.$route.query.yanse == 1">
        <p class="flow_h tit_public colorF"><span class="tit_span" style="margin-right:2em;">中国银行</span><span class="tit_span">顺德农商</span></p>
      </div>   
      <div class="factoring_nav tit_public" v-if="this.$route.query.yanse == 2 && this.$route.query.productName =='正向保理'">
        <p class="flow_h tit_public colorF"><span class="tit_span" style="margin-right:2em;">回购型</span><span class="tit_span">明保理</span></p>
      </div>           
      <div class="factoring_nav tit_public" v-if="this.$route.query.yanse == 2 && this.$route.query.productName !='正向保理'">
        <!-- <button class="" :class="{cur:isBright}">保理业务</button> -->
        <button class="bright" :class="{cur:isBright}" @click="bright()">明保理</button>
        <button class="dark" :class="{cur:isDark}" @click="dark()">暗保理</button>
      </div>
      <!-- 供应链业务介绍 -->
      <div class="presentation" v-if="this.$route.query.yanse == 1">
        <div class="presentation_l f_public">
          <div style="color:#EB662B;">无追索</div>
          <div style="font-size: 16px;width:320px;">买方的逾期付款风险由银行承担</div>
        </div>
        <div class="presentation_r f_public">
          <div style="color:#EB662B;">100%</div>
          <div style="font-size: 16px;width:320px;">无需保证金，买方应付金额即为可融资金额</div>
        </div>
      </div>   
      <!-- 正向保理介绍 -->   
      <div class="presentation" v-if="this.$route.query.yanse == 2 && this.$route.query.productName =='正向保理'">
        <div class="presentation_l f_public">
          <div style="color:#EB662B;">回购型</div>
          <div style="font-size: 14px;width:320px;text-align: left;line-height: 30px;">保理商和供应商约定，在供应商融资到期后，若买方不能如期足额支付货款的，供应商负责融资额回购义务</div>
        </div>
        <div class="presentation_r f_public">
          <div style="color:#EB662B;">明保理</div>
          <div style="font-size: 14px;width:320px;text-align: left;line-height: 30px;">供应商在转让应收账款后，出具《应收账款转让通知书》并寄送到买方，明确告知买方债权已转让，付款路径需变更至指定收款账户</div>
        </div>
      </div>            
      <!--明保介绍-->
      <div class="presentation" v-show="isBright" v-if="this.$route.query.yanse == 2 && this.$route.query.productName !='正向保理'">
        <p class="presentation_tit">借款人借款，核心企业知晓给你应收账款的保理业务</p>
        <div class="presentation_l f_public">
          <div style="color:#EB662B;">回购型</div>
          <p>借款人借款，核心企业到期付款给平台, 若不付款则由借款人付款</p>
        </div>
        <div class="presentation_r f_public">
          <div style="color:#EB662B;">买断型</div>
          <p>借款人借款，核心企业到期付款给平台, 若拒付风险由平台承担</p>
        </div>
      </div>
      <!-- &lt;!&ndash;暗保介绍&ndash;&gt; -->
      <div class="presentation" v-show="isDark" v-if="this.$route.query.yanse == 2">
        <p class="presentation_tit">借款人借款，核心企业知晓给你应收账款的保理业务</p>
        <div class="f_public presentation_dark">
          <div style="color:#EB662B;">还款方式</div>
          <p>借款人借款，核心企业到期付款给平台, 若拒付风险由平台承担</p>
        </div>
      </div>
      <!--申请流程-->
      <div class="flow">
        <p class="flow_h tit_public colorF"><span class="tit_span">申请流程</span></p>
        <ul class="flow_list">
          <li class="flow_li" v-for="(item,index) in flowArr" :key="index">
            <div class="flow_icon">
              <!--<img src="../../assets/images/icon1.png" alt="">-->
              <img :src="item.url" alt="">
            </div>
            <span class="flow_name colorF">{{item.flowName}}</span>
            <p class="flow_tit">{{item.flowDetails}}</p>
          </li>

        </ul>
      </div>
      <!--申请流程-->


      <!--申请条件及所需资料-->
      <div class="condition">
        <p class="condition_h tit_public"><span class="tit_span">流程资料</span></p>
        <ul class="condition_list">
          <li class="condition_li" v-for="(item,index) in conditionArr" :key="index">
            <span>{{item.compactName}}</span>
            <p style="text-indent:2em;">{{item.compactMain}}</p>
          </li>
        </ul>

      </div>
    </div>
    <!--主要内容-->
  </div>
</template>

<script>
  import Blapi from '../../api/details.js';
  import _ from 'lodash';
  import {mapGetters, mapActions} from 'vuex';
  import api from '../../vuex/api';
  import applyloanApi from '../../api/applyloan';
  import loanApi from '../../api/myloan_bl';
  import * as types from '../../vuex/types';

  export default {
    // name: "factoring".
    data () {
      return {
        isBright: true,
        isDark: false,
        flowArr: [
          {url: require('../../assets/images/icon1.png'), flowName: '额度申请', flowDetails: '额度申请，平台进 行客户尽调授信'},
          {url: require('../../assets/images/icon2.png'), flowName: '应收账款录入', flowDetails: '贸易合同，应收账 款录入'},
          {url: require('../../assets/images/icon3.png'), flowName: '交易关系确定', flowDetails: '融资申请审核，融 资比例及利率确定'},
          {url: require('../../assets/images/icon4.png'), flowName: '签订合同', flowDetails: '借款合同/担保合同签订'},
          {url: require('../../assets/images/icon5.png'), flowName: '放款', flowDetails: '合同审核通过后2-3 个工作日放款'},
          {url: require('../../assets/images/icon6.png'), flowName: '还款', flowDetails: '在我的账户查看还 款记录，到期还款 /提前还款'}
        ], // 流程申请
        conditionArr: [
          {compactName: '01 合同信息', compactMain: '录入贸易基本信息，上 传合同附件，如果已经 录入过同样的合同则只 需要选择合同将会带出 合同信息'},
          {compactName: '02 发票信息', compactMain: '上传发票附件'},
          {compactName: '03 担保方信息', compactMain: '可选择录入担保方信息 ，加速融资进度，提高 融资比例可选择担保方 式，质押担保，抵押担 保，信用担保'},
          {compactName: '04 担保品信息', compactMain: '采用抵押担保模式需要 提供担保品信息（名称 ，数量价值等）'}
        ],
        productName: this.$route.params.productName, // 名称

        hasLoanAmount: false,
        askLoanSuccess: true,
        productId: this.$route.query.productId,
        draftApply:{}
        // applyLoanBtn: {
        //   diabled: true,
        //   text: '立即申请'
        // }
      };
    },
    computed: {
      ...mapGetters({
        imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
        userInfo: types.GET_USER,
        companyInfo: types.GET_COMPANY_INFO,
        productDetails: types.GET_PRODUCT_DETAILS,
        isUseingLimit: types.IS_USEING_LIMIT
      })
    },
    created () {
      this.datailsData();
      this.$route.query.yanse;
    },
  
    methods: {
      ...mapActions({
        getProductDetails: types.GET_PRODUCT_DETAILS,
        setAlertMessage: types.SET_FAIL_MESSAGE,
        getApplicationQuota: types.GET_APPLICATION_QUOTA,
        getAvailableAmount: types.GET_AVAILABLE_AMOUNT
      }),
      // 明保单击事件
      bright () {
        this.isBright = true;
        this.isDark = false;
      },

      // 暗保单击事件
      dark () {
        this.isBright = false;
        this.isDark = true;
      },
        // 获取产品详情数据
      datailsData () {
        const _this = this;
        const productId = _this.$route.query.productId;
        Blapi.getDetails({productId}).then((res) => {
          if (res.code == 0) {
            _this.productName = res.data.productName;
          }
        }).catch((error) => {

        });
      },

      fixHTMLLineSeparator (str) {
        if (_.isString(str)) {
          return `<p>${str.split('\n').join('</p><p>')}</p>`;
        }
      },
  
      beginApplyLoan () {
        const _this = this;
        const productName = this.productName;
        const productId = this.productId;
        if (!_.isEmpty(this.userInfo)) {
          api.isCurrentUserInBlacklist({// 该接口仅有此处用到，也与state关系不大，暂不考虑放入store，减轻复杂度
            token: this.userInfo.token,
            productId: this.productId
          }).then((res) => {
            const resData = res.data;
            if (Number(resData.code) === 0) { // 不在黑名单，正常进入流程
              if (productName.includes('供应链')) {
                this.goBlProcess({productId, yanse: 1, productName});
              } else {
                if (productName.includes('池保理')) { // 池保理产品
                  loanApi.getPoolItemDetails({ // 详情
                    tokenId: localStorage.getItem('dl_tokenId_bl')
                  }).then((res) => {
                    if (res.code == 2) {
                      _this.setAlertMessage({
                        show: true,
                        content: res.msg
                      });
                    } else if (res.code == 0) {
                      this.$router.push({path: `/loanDetail_bl_pool`});
                    } else {
                        // 未申请过池保理
                      this.goBlProcess({productId, yanse: 2, productName});
                    }
                  });
                } else {
                  this.goBlProcess({productId, yanse: 2, productName});
                }
              }
            } else if (Number(resData.code) === 5) { // 未填写个人或企业信息
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
              this.$router.push('/personalCenter/MyInfo');
            } else if (Number(resData.code) === 3) { // 未实名验证
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
              this.$router.push('/personalCenter/realNameAuth');
            } else if (Number(resData.code) === 2) { // 未添加银行卡
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
              this.$router.push('/personalCenter/bankcardInfo');
            } else if (Number(resData.code) === 9) { // 未额度授信
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
            } else { // 在黑名单，给出提示
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
            }
          }).catch((error) => {
            _this.$Error(_this, error);
          });
        } else {
          // 没有登录
          this.$router.push('/login');
        }
      },
	   /**
       * 查询草稿项目
       */
      getDraftApply(){
          let baseProductId = this.$route.query.productId;
          applyloanApi.getDraftApply(baseProductId).then((res) => {
          if (Number(res.data.code) === 0) {
            this.draftApply = res.data.result
          } else {
            this.setFailMessage({
              show: true,
              content: res.msg || '数据获取失败'
            });
          }
        }).catch((error) => {
          console.error(error)
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      },
    /**
     * 跳转项目流程
     */
    goBlProcess ({productId, yanse, productName}) {
      applyloanApi.getDraftApply(productId).then((res) => {
        if (Number(res.data.code) === 0) {
          const apply = res.data.result; // 草稿项目
          if (!apply) {
            // 跳转项目流程第一步
            this.$router.push({
              path: `/applyLoan/${productId}/step2_bl`,
              query: {yanse, productName}
            });
          }

          const query = {
            frontApplyId: apply.frontApplyId,
            isEdit: true,
            yanse,
            productName
          };
          switch (apply.applyState) {
            case 'f1':
              // 跳转第二步
              this.$router.push({
                path: `/applyLoan/${productId}/step3_bak_bl`,
                query: {
                  ...query,
                  selectedBankcardId: apply.bankAccountId
                }
              });
              break;
            case 'f2':
              // 跳转第三步
              this.$router.push({
                path: `/applyLoan/${productId}/step3_bl`,
                query: {
                  ...query,
                  selectedBankcardId: apply.bankAccountId
                }
              });
              break;
            case 'f3':
              // 跳转第四步
              this.$router.push({
                path: `/applyLoan/${productId}/step4_bl`,
                query: {
                  ...query,
                  selectedBankcardId: apply.bankAccountId
                }
              });
              break;
            case 'f4':
              // 跳转第五步
              this.$router.push({
                path: `/applyLoan/${productId}/step5_bl`,
                query
              });
              break;
            default:
              // 跳转第一步
              this.$router.push({
                path: `/applyLoan/${productId}/step2_bl`,
                query
              });
              break;
          }
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || '数据获取失败'
          });
        }
      }).catch((error) => {
        console.error(error);
        this.setFailMessage({
          show: true,
          content: '网络异常，请稍后再试'
        });
      });
    }

    },
  
    mounted () {
      this.getProductDetails({
        // productId: this.$route.params.id
        productId: this.$route.query.productId
      });
      this.getDraftApply(); // 查询草稿项目
      if(this.$route.query.yanse == 1){
        this.flowArr = [
            {url: require('../../assets/images/icon1.png'), flowName: '三方协议', flowDetails: '供应商、宏和、银行签订三方协议'},
            {url: require('../../assets/images/icon2.png'), flowName: '提交结算申请', flowDetails: '在本系统向买方提交供应链结算申请'},
            {url: require('../../assets/images/icon3.png'), flowName: '审核结算申请', flowDetails: '买方核对发票并确认应付'},
            {url: require('../../assets/images/icon4.png'), flowName: '受理买方应付', flowDetails: '银行受理买方应付信息'},
            {url: require('../../assets/images/icon5.png'), flowName: '提交融资申请', flowDetails: '在本系统向银行提交融资申请'},
            {url: require('../../assets/images/icon6.png'), flowName: '审批放款', flowDetails: '银行收取资料并审批放款'}
          ]; // 流程申请
          this.conditionArr = [
            {compactName: '01 贸易合同', compactMain: '与买方的贸易合同（购销合同、OEM合同等）'},
            {compactName: '02 发票信息', compactMain: '与本次融资相关的发票资料'},
            {compactName: '03 系统附件', compactMain: '完成系统操作后，打印系统生成的相关资料'},
            {compactName: '04 其他', compactMain: '银行需要的其他资料'}
          ];
      }else if(this.$route.query.yanse == 2 && this.$route.query.productName =='正向保理'){
          this.flowArr = [
            {url: require('../../assets/images/icon1.png'), flowName: '客户准入', flowDetails: '客户实名认证并签订保理合同'},
            {url: require('../../assets/images/icon2.png'), flowName: '融资申请', flowDetails: '在本系统提交应收账款相关资料并提出融资申请'},
            {url: require('../../assets/images/icon3.png'), flowName: '签订业务合同', flowDetails: '签订系统生成的单笔业务附件'},
            {url: require('../../assets/images/icon4.png'), flowName: '放款审批', flowDetails: '根据融资产品及信用等级审批并放款'},
            {url: require('../../assets/images/icon5.png'), flowName: '贷后管理', flowDetails: '日常联络、尽调并核查发票情况'},
            {url: require('../../assets/images/icon6.png'), flowName: '回款登记', flowDetails: '业务到期后登记回款或发起回购'}
          ]; // 流程申请
          this.conditionArr = [
            {compactName: '01 贸易合同', compactMain: '与买方的贸易合同（购销合同、OEM合同等）'},
            {compactName: '02 发票信息', compactMain: '与本次融资相关的发票资料'},
            {compactName: '03 系统附件', compactMain: '完成系统操作后，打印系统生成的相关资料'},
            {compactName: '04 其他', compactMain: '根据融资产品提供其他附件（担保、抵押等）'}
          ];
      }
    }
  };
</script>

<style scoped lang="scss">
  .w {
    width: 1140px;
    margin: 0 auto;
  }

  .colorF {
    // color: #EB662B
  }

  /*公共样式*/
  .tit_public {
    font-size: 26px;
    text-align: center;
    color: #EB662B;
    margin: 74px 0 30px 0;
    .tit_span {
      border-bottom: 1px solid #EB662B;
      padding-bottom: 5px;
    }
  }

  /*顶部介绍*/
  .factoring {
    width: 100%;
    height: 451px;
    /*background: url(../../assets/images/product.jpg) center center no-repeat;*/
    position: relative;
    color: #fff;
    .factoring_Img{
      width: 100%;
      height: 451px;
      position: absolute;
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
    }
    .factoring_tit {
      text-align: center;
      position: absolute;
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
      .factoring_h {
        font-size: 40px;
        padding-bottom: 38px;
        padding-top: 330px;
      }
      .limit-baoli{
        width:100%;
        height:372px;
        border-radius:4px;
        background: url(../../assets/images/icon7.png) no-repeat;
        background-size:100% 100%; 
        ul{
              padding-top: 70px;
              height: 180px;
        }
        .limit {
          width: 50%;
          float: left;
          // padding-top: 20px;
          // border: 1px solid #fff;
          // margin-bottom: 30px;
          p{
           
            font-size: 22px;
            padding: 12px 0;
            color: #333333;
            
          }
          span {
            display: inline-block;
            width: 260px;
            font-size: 16px;
            color: #666666;
                text-align: left;
          }
  
        }
      .factoring_btn {
        width: 160px;
        line-height: 38px;
        font-size: 18px;
        color: #fff;
        background: #EB662B;
        border-radius: 20px;
        display: block;
        margin: 0 auto;
        outline: none;
        border: none;
        cursor: pointer;
      }
      }
    }
  }

  /*内容导航*/
  .factoring_nav {
    padding-top: 200px;
    button {
      background: none;
      border: none;
      outline:none;
    }
    .bright, .dark {
      color: #666666;
      padding-bottom: 5px;
      cursor: pointer;
      &:hover {
        color: #EB662B;
        border-bottom: 1px solid #EB662B;
      }

    }
    .bright {
      margin-right: 30px;
    }
    .cur {
      color: #EB662B;
      border-bottom: 1px solid #EB662B;
    }
  }

  /*保理介绍*/
  .presentation {
    background: url(../../assets/images/bg_mabl.png) center center no-repeat;
    
    padding: 34px;
    color: #666666;
    margin-bottom: 79px;
    @include clear;
    .f_public {
      width: 466px;
      height: 94px;
      border: 1px solid #FFFFFF;
      box-sizing: border-box;
      div {
        width: 140px;
        line-height: 94px;
        text-align: center;
        @include floatLeft;
        font-size: 26px;
      }
      p {
        width: 320px;
        line-height: 35px;
        padding-top: 10px;
        @include floatRight;
        font-size: 16px;
      }
    }
    .presentation_tit {
      font-size: 18px;
      text-align: center;
      padding-bottom: 30px;
    }
    .presentation_l {
background-color: #FFFFFF;
    box-shadow:0px 3px 49px 0px rgba(0, 0, 0, 0.1);
      @include floatLeft;

    }
    .presentation_r {
background-color: #FFFFFF;
    box-shadow:0px 3px 49px 0px rgba(0, 0, 0, 0.1);
      @include floatRight;
    }
    .presentation_dark {
      /*margin: 0 auto;*/
      background-color: #FFFFFF;
      box-shadow:0px 3px 49px 0px rgba(0, 0, 0, 0.1);
    }
  }

  /*流程申请*/
  .flow {
    .flow_list {
      padding-top: 30px;
      text-align: center;
      @include clear;
      position: relative;
      &:before{
        content: "";
        width: 90%;
        border: 1px dashed #C6972D;
        display: block;
        position: absolute;
        top: 75px;
        left: 20px;
        z-index: -999;
      }
      .flow_li {
        width: 128px;
        float: left;
        margin-right: 72px;
        &:last-of-type {
          margin-right: 0;
        }
        .flow_icon {
          margin: 0 auto;
          width: 92px;
          height: 92px;
          box-sizing: border-box;
          padding-top: 25px;
          border-radius: 50px;
          img{
                margin-top: -26px;
          }
        }
        .flow_name {
          font-size: 18px;
          display: inline-block;
          margin: 14px 0;
        }
        .flow_tit {
          line-height: 24px;
          font-size: 16px;
          color: #666;
        }
      }

    }
  }

  /*申请条件*/
  .condition {
    .condition_list {
      padding: 20px 0 80px 0;
      @include clear;
      .condition_li {
        float: left;
        width: 212px;
        height: 225px;
        box-sizing: border-box;
        padding: 30px 12px 0 25px;
        background: url(../../assets/images/img_sqtj.png);
        color: #666666;
        margin-right: 90px;
        &:last-of-type {
          margin-right: 0;
        }
        span {
          color: #FFFFFF;
          line-height: 45px;
          font-size: 20px;
        }
        p {
          font-size: 16px;
          line-height: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Factoring.vue?4443108a